export { AssetsPage } from './assets_page';
